export default __webpack_public_path__ + "static/media/parc4.83ef9794.png";